import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { enableMapSet } from 'immer';
import App from './App';
import { installPreloadErrorRecovery } from './services/preloadRecovery';
import { handleOAuthCallbackAtBoot } from './components/modules/google-drive/googleDriveOAuth';
import './styles/globals.css';

// E.21.31.1 (2026-05-04): zustand's immer middleware uses immer drafts;
// mutating a Map or Set inside a draft (e.g. `state.expandedFolders.add(id)`
// in projectStore.toggleFolder) is a SILENT NO-OP without this plugin
// enabled. Pre-fix the FilesPanel folder-expand clicks did nothing because
// every toggleFolder call's mutation was discarded by immer. Must be called
// once at app entry (here) BEFORE any zustand store with immer middleware
// is constructed.
enableMapSet();

// Recover a stale tab when a lazy module chunk 404s after a server redeploy
// (Vite `vite:preloadError`) — reload once to fetch the fresh bundle instead
// of leaving the module tile stuck on "Module failed to load".
installPreloadErrorRecovery();

// Google Drive OAuth (2026-07-29 P0): if this tab is the Google consent
// callback (`/modules/google-drive/callback?code&state`), deliver the pair to
// the opener + close (popup) or stash + return to the app (full redirect), and
// do NOT boot the full SPA. No-op on every other URL.
if (!handleOAuthCallbackAtBoot()) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
